import { Box, useTheme } from '@mui/material'
import { BaseImage } from '../baseImage/baseImage'

export const ImageBreakerCallout = ({ children, mobileLong = false, ...props }) => {
  const theme = useTheme()

  // Only the 0–599px view diverges when mobileLong is set. The 600–899px band
  // and desktop (900px+) keep the original treatment untouched.
  const mq = '@media (max-width:599px)'

  return (
    <Box {...props}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: { xs: `calc(100% + ${theme.spacing(6)})`, md: '100vw' },
          transform: {
            xs: `translateX(-${theme.spacing(3)})`,
            md: `translateX(calc((900px - 100vw) / 2))`,
          },
          overflow: 'hidden',
          backgroundColor: 'transparent',
          backgroundImage: 'url(/images/breaker/breaker-bg.webp)',
          backgroundSize: 'cover',
          backgroundPosition: 'bottom center',
          backgroundRepeat: 'no-repeat',
          position: 'relative',
          ...(mobileLong && {
            [mq]: {
              width: 'calc(100% + 48px)',
              transform: 'translateX(-24px)',
              backgroundImage: 'url(/images/breaker/breaker-long.webp)',
              aspectRatio: '1 / 1.233',
            },
          }),
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: { xs: 'clamp(-340px, calc(50vw - 580px), 0px)', md: 'auto' },
            right: { xs: 'auto', md: 'calc(100vw - 350px)' },
            width: { xs: '545px', md: '490px' },
            ...(mobileLong && { [mq]: { display: 'none' } }),
          }}
        >
          <BaseImage
            alt=""
            src="/images/breaker/breaker-trees-l.webp"
            width="956"
            height="494"
            sources={[<source key="m" media="(max-width: 899px)" srcSet="/images/breaker/breaker-trees-l-mobile.webp" />]}
            sx={{ height: 'auto', width: '100%', display: 'block' }}
          />
        </Box>
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 'clamp(calc(100% - 360px), 50%, calc(100% - 100px))',
            width: { xs: '760px', md: '670px' },
            ...(mobileLong && { [mq]: { display: 'none' } }),
          }}
        >
          <BaseImage
            alt=""
            src="/images/breaker/breaker-trees-r.webp"
            width="1320"
            height="494"
            sources={[<source key="m" media="(max-width: 899px)" srcSet="/images/breaker/breaker-trees-r-mobile.webp" />]}
            sx={{ height: 'auto', width: '100%', display: 'block' }}
          />
        </Box>
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: { xs: 'clamp(-20px, 35vw - 154px, 154px)', md: 'clamp(0px, 35vw, 154px)' },
            width: { xs: '240px', md: '260px' },
            ...(mobileLong && { [mq]: { display: 'none' } }),
          }}
        >
          <BaseImage
            alt="Woman on a hike drinking from a water bottle"
            src="/images/breaker/breaker-subject.webp"
            width="484"
            height="492"
            sx={{ height: 'auto', width: '100%', display: 'block' }}
          />
        </Box>
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: { xs: '280px', md: '250px' },
            overflow: 'hidden',
            ...(mobileLong && { [mq]: { height: '100%' } }),
          }}
        >
          <Box
            className="content-header"
            sx={{
              display: 'flex',
              width: '100%',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: 2.5,
              padding: '0',
              height: '100%',
              margin: 0,
              left: 0,
              backgroundColor: 'transparent',
            }}
          >
            <Box
              className="label"
              variant="h1"
              sx={(theme) => ({
                width: { xs: 'calc(100% - 150px)', sm: '50%', md: '60%' },
                lineHeight: 1,
                fontWeight: 700,
                color: 'primary.main',
                backgroundColor: 'secondary.main',
                fontSize: { xs: '1.5rem', md: '1.75em' },
                padding: theme.spacing(2, 2, 2, 6),
                borderRadius: theme.spacing(15, 0, 0, 15),
                margin: 0,
                display: 'flex',
                alignItems: 'center',
                ...(mobileLong && {
                  [mq]: {
                    padding: '25px 16px 25px 40px',
                    borderRadius: '80px 0 0 80px',
                  },
                }),
              })}
            >
              {children}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}